

























import { EnumType } from 'expangine-runtime';
import { EnumSubs } from './EnumTypes';
import { friendlyList } from '../../../common';
import TypeEditorBase from '../TypeEditorBase';


export default TypeEditorBase<EnumType, any, EnumSubs>().extend({
  name: 'EnumEditor',
  computed: {
    description(): string {
      return friendlyList(Array.from(this.type.options.constants.keys()));
    },
  },
});
